import axios from "axios";

export default axios.create({
  baseURL: "https://www.globalmatch.nl/api/v1.0"
  // baseURL: "http://localhost/globalmatch/api/v1.0"
});